import React from "react";

// Shown when a panel is opened without the personal link that carries the user's ID.
export default function NoAccess({ panelName = "Panel", param = "id" }) {
  return (
    <div style={styles.screen}>
      <div style={styles.card}>
        <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#f87171" strokeWidth="1.8" aria-hidden="true">
          <rect x="4" y="11" width="16" height="10" rx="2" />
          <path d="M8 11V7a4 4 0 0 1 8 0v4" />
        </svg>
        <h2 style={styles.title}>{panelName}</h2>
        <p style={styles.desc}>
          Please open this panel from inside the app using your personal link.
        </p>
        <p style={{ ...styles.desc, direction: "rtl" }}>
          من فضلك افتح اللوحة من داخل التطبيق باستخدام الرابط الخاص بك.
        </p>
        <div style={styles.codeBlock}>
          <code style={styles.code}>{window.location.origin}/?{param}=YOUR_ID</code>
        </div>
        <p style={styles.hint}>Contact the administrator if you believe this is a mistake.</p>
      </div>
    </div>
  );
}

const styles = {
  screen: {
    minHeight: "100vh",
    backgroundColor: "#0f1117",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "system-ui, -apple-system, 'Segoe UI', Tahoma, sans-serif",
    padding: "16px",
    boxSizing: "border-box",
  },
  card: {
    backgroundColor: "#1a1d27",
    border: "1px solid #2a2d3a",
    borderRadius: "16px",
    padding: "40px 32px",
    maxWidth: "440px",
    width: "100%",
    textAlign: "center",
    boxSizing: "border-box",
  },
  title: { color: "#f1f1f1", fontSize: "22px", fontWeight: 600, margin: "16px 0 12px" },
  desc: { color: "#9ca3af", fontSize: "14px", lineHeight: 1.7, margin: "0 0 12px" },
  codeBlock: {
    backgroundColor: "#0f1117",
    border: "1px solid #2a2d3a",
    borderRadius: "8px",
    padding: "12px 16px",
    margin: "8px 0 20px",
    wordBreak: "break-all",
  },
  code: { color: "#e879a0", fontSize: "12px" },
  hint: { color: "#6b7280", fontSize: "13px", margin: 0 },
};
